<template>
  <!-- <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar> -->
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Workflow</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/aikey">AI Chat</router-link>
                  </li>
                  <li class="breadcrumb-item active">Workflow</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <!-- <a
                  ref="formBc"
                  class="btn add-btn"
                  @click="showBroadcast(true)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="fa fa-flash"></i> Add
                </a> -->
              </div>
              <a
                v-show="false"
                ref="formBcEdit"
                class="btn add-btn"
                @click="showBroadcast(false)"
                href="#"
                data-toggle="modal"
                data-target="#add_form"
              >
                <i class="fa fa-whatsapp"></i> Edit
              </a>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.intent_code"
                  type="text"
                />
                <label class="focus-label">Title</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <select
                  class="form-control"
                  v-model="serverParams.columnFilters.is_active"
                >
                  <option :value="null">-- Select --</option>
                  <option :value="1">Active</option>
                  <option :value="0">Inactive</option>
                </select>
                <label class="focus-label">Status Active</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <licenseSelect v-model="selectedContact" />
            </div>

            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="searchData"
                class="btn btn-success btn-block"
                >Search</a
              >
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionDelete"
                  class="btn btn-danger btn-block"
                >
                  <i class="la la-trash"></i> Remove
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionDraft"
                  class="btn btn-warning btn-block"
                >
                  <i class="la la-pause"></i> Draft
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionPublish"
                  class="btn btn-success btn-block"
                >
                  <i class="la la-check"></i> Publish
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div
              class="col-md-12 alert alert-primary"
              style="text-align: justify"
            >
              Kini Waajo dapat terhubung langsung dengan sistem internal Anda
              melalui Workflow HTTP Request!
              <ol>
                <li>
                  Dynamic API: Ambil data produk, status member, atau buat
                  invoice otomatis lewat chat.
                </li>
                <li>
                  Secure OTP: Kirim kode verifikasi lebih aman dengan
                  validasi nomor otomatis.
                </li>
                <li>
                  Custom Workflow: Butuh alur khusus? Tim kami siap buatkan
                  untuk bisnis Anda.
                </li>
              </ol>

              Catatan: Fitur ini masih dalam tahap akses terbatas (Limited
              Access). Hubungi tim support untuk aktivasi.
            </div>
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <!-- <th>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="selectAllTable" />
                          </label>
                        </div>
                      </th> -->
                      <th>No</th>
                      <th>Nama Lisensi</th>
                      <th>No WA</th>
                      <th>Kode Intent</th>
                      <th>URL API</th>
                      <th>Prompt System</th>
                      <th>Status</th>
                      <!-- <th>#</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="5">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td>
                          <!-- <div class="checkbox">
                            <label>
                              <input
                                type="checkbox"
                                v-model="selectedTable"
                                :value="row"
                              />
                            </label>
                          </div> -->
                          {{ row.number }}
                        </td>
                        <td class="text-wrap">
                          <span>{{ row.license_name }}</span>
                        </td>
                        <td class="text-wrap">
                          <span>{{ row.license_phone_number }}</span>
                        </td>
                        <td class="text-wrap">
                          <span>{{ row.intent_code }}</span>
                        </td>
                        <td class="text-wrap">
                          <span>{{ row.base_url }}{{ row.endpoint_path }}</span>
                        </td>

                        <td style="max-width: 600px">
                          <div
                            class=""
                            style="word-wrap: break-word; white-space: initial"
                          >
                            <!-- {{ row.note }} -->
                            <!-- <ExpandParagraph :text="row.note.replace('\n', '<br>')" :limit="5" /> -->
                            <button
                              class="btn btn-sm btn-outline-info"
                              data-toggle="modal"
                              :data-target="'#promptModal_' + row.id"
                            >
                              Lihat Prompt
                            </button>

                            <PromptViewerModal
                              :id="'promptModal_' + row.id"
                              :title="'Prompt System'"
                              :text="row.note"
                            />
                          </div>
                          <!-- <div style="font-size: 12px" class="text-muted">
                            {{ row.footer_message }}
                          </div> -->
                        </td>

                        <td>
                          <div>
                            <!-- <select
                              v-model="row.is_active"
                              class="form-control form-control-sm"
                            >
                              <option value="1">Active</option>
                              <option value="0">Non-Active</option>
                            </select> -->
                            <CustomSwitch
                            :disabled="true"
                              v-model="row.is_active"
                              :true-value="'1'"
                              :false-value="'0'"
                              true-label="Aktif"
                              false-label="Nonaktif"
                            />
                          </div>
                        </td>
                        <!-- <td>
                          <div class="dropdown action-label">
                            <a
                              class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                              href="#"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-danger"></i>
                              Options
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              
                              <a class="dropdown-item">
                                <i class="fa fa-pencil text-success"></i> Edit
                              </a>
 
                              <a class="dropdown-item">
                                <i class="fa fa-trash-o text-danger"></i> Remove
                              </a>
                            </div>
                          </div>
                        </td> -->
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row" v-if="rows.length > 0">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width: 100px"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                  {
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage),
                  }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      <!-- </div> -->
      <!-- /Page Wrapper -->
    <!-- </div> -->

    <form-data :searchData="fetchData" />
  </div>
</template>

<script>
import {
  currentDateTimeUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  formatLocalDateWithDay,
  getWhatsappNumberFromJid,
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import CustomSwitch from "@/components/CustomSwitch.vue";
import FormData from "./form.vue";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import licenseSelect from "../../license/licenseSelect.vue";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/SidebarChatbot.vue";
import ExpandParagraph from "./components/ExpandParagraph.vue";
import PromptViewerModal from "./components/PromptViewerModal.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    licenseSelect,
    Skeleton,
    Multiselect,
    ExpandParagraph,
    FormData,
    PromptViewerModal,
    CustomSwitch,
  },
  data() {
    return {
      selectedTable: [],
      selectedContact: null,
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      requester: null,
      channel: null,
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          intent_code: "",
          license_id: "",
          is_active: "",
        },
        page: 1,
        perPage: 20, // perPage
      },
    };
    //  isactive : true
  },
  computed: {
    selectAllTable: {
      get: function () {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function (value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function (row) {
            // selectedTable.push(row.id);
            selectedTable.push(row);
          });
        }

        this.selectedTable = selectedTable;
      },
    },
  },
  watch: {
    selectedContact(val) {
      if (val) {
        this.serverParams.columnFilters.license_id = val[0].id;
      } else {
        this.serverParams.columnFilters.license_id = "";
      }
    },
  },
  created() {
    this.loadItems();
    // let response = {
    //   status: 200,
    //   msg: "OK",
    //   data: {
    //     page: 0,
    //     recordsFiltered: "20",
    //     totalRecords: "6",
    //     data: [
    //       {
    //         number: 1,
    //         id: "6",
    //         network_id: "1",
    //         intent_code: "CREATE_INVOICE",
    //         service_name: "",
    //         base_url: "http://localhost:8500/prod",
    //         endpoint_path: "/go-omni/v1/order/create-invoice-byemailwa",
    //         http_method: "POST",
    //         auth_type: "basic",
    //         credential_encrypted: "",
    //         headers_json:
    //           '{"Authorization":"Basic dGVqb211cnRpcHJvamVjdDphRjdMRHl4IWghd2QkTHlTOn5Aa0BNOVt2Un1fd2Z7LQ=="}',
    //         request_mapping_json:
    //           '{\r\n   "email_or_nowa_login":"$.entities.email_or_nowa_login",\r\n    "license_no_wa":"$.entities.license_no_wa",\r\n    "is_for_new_license": "$.entities.is_for_new_license",\r\n    "product_code":"$.entities.product_code"\r\n}',
    //         response_mapping_json:
    //           '{\r\n  "success": "$.success",\r\n  "code": "$.code",\r\n  "message": "$.message",\r\n  "message_type": "$.data.message_type",\r\n  "message_caption": "$.data.message_caption",\r\n  "message_file_url": "$.data.message_file_url"\r\n}',
    //         is_active: "1",
    //         note: '### PARAMETER INTENT CREATE_INVOICE\n1. **email_or_nowa_login** (Mandatory): Email atau No WA login akun Waajo.\n2. **product_code** (Mandatory): Kode paket lisensi. \n   - JANGAN mengarang kode. \n   - Jika belum ada, arahkan user untuk cek paket melalui intent TANYA_PRODUK_WAAJO.\n3. **is_for_new_license** (Hidden Logic):\n   - Set "1" jika user ingin MENAMBAH slot lisensi baru.\n   - Set "0" jika user ingin MEMPERPANJANG lisensi yang sudah ada.\n4. **license_no_wa** (Optional): \n   - Jika user ingin perpanjang nomor WA tertentu, isi dengan nomor tersebut.\n   - Jika dikosongkan, sistem otomatis memperpanjang lisensi yang paling dekat masa kedaluwarsanya.\n\n### RULES & CONSTRAINTS\n- JANGAN tanyakan "is_for_new_license" kepada user secara teknis. Simpulkan dari konteks: "tambah baru" vs "perpanjang".\n- Jika user tidak memberikan product_code, tawarkan bantuan untuk melihat daftar produk terlebih dahulu.\n- Pastikan format email/nowa valid sebelum mengirim data.\n- Konfirmasi pesanan (Product + Akun) sebelum melakukan submit final.',
    //         create_datetime: "1768135661",
    //         update_datetime: "1768135661",
    //         license_id: "8ee48521-f786-4e4c-96ee-9906455d32a5",
    //         is_filling_form: "0",
    //         is_webhook_default: "1",
    //         webhook_url: "",
    //         license_name: "Boss Tejo",
    //         license_phone_number: "6285274397773",
    //       },
    //       {
    //         number: 2,
    //         id: "5",
    //         network_id: "1",
    //         intent_code: "BUAT_PESANAN_WITH_SHEET",
    //         service_name: "saveToSpreedsheet",
    //         base_url: "http://localhost:8500/prod",
    //         endpoint_path: "",
    //         http_method: "POST",
    //         auth_type: "",
    //         credential_encrypted: "",
    //         headers_json:
    //           '{"Content-Type":"application/json","Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk"}',
    //         request_mapping_json:
    //           '{\r\n  "message": "$.entities.message",\r\n  "nowa": "$.entities.nowa"\r\n}',
    //         response_mapping_json:
    //           '{\r\n  "success": "$.success",\r\n  "code": "$.code",\r\n  "message": "$.message",\r\n  "message_type": "$.data.message_type",\r\n  "message_caption": "$.data.message_caption",\r\n  "message_file_url": "$.data.message_file_url"\r\n}',
    //         is_active: "1",
    //         note: "tanya terkait contoh AI Workflow pemesanan ruang meeting atau meeting room",
    //         create_datetime: "1768135661",
    //         update_datetime: "1768135661",
    //         license_id: "8ee48521-f786-4e4c-96ee-9906455d32a5",
    //         is_filling_form: "0",
    //         is_webhook_default: "1",
    //         webhook_url: "",
    //         license_name: "Boss Tejo",
    //         license_phone_number: "6285274397773",
    //       },
    //       {
    //         number: 3,
    //         id: "4",
    //         network_id: "1",
    //         intent_code: "TANYA_PRODUK_WAAJO",
    //         service_name: "getAllProduct",
    //         base_url: "http://localhost:8500/prod",
    //         endpoint_path: "",
    //         http_method: "POST",
    //         auth_type: "",
    //         credential_encrypted: "",
    //         headers_json:
    //           '{"Content-Type":"application/json","Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk"}',
    //         request_mapping_json:
    //           '{\n  "message": "$.entities.message",\n  "nowa": "$.entities.nowa"\n}',
    //         response_mapping_json:
    //           '{\r\n  "success": "$.success",\r\n  "code": "$.code",\r\n  "message": "$.message",\r\n  "message_type": "$.data.message_type",\r\n  "message_caption": "$.data.message_caption",\r\n  "message_file_url": "$.data.message_file_url"\r\n}',
    //         is_active: "1",
    //         note: "tanya tentang produk waajo",
    //         create_datetime: "1768135661",
    //         update_datetime: "1768135661",
    //         license_id: "8ee48521-f786-4e4c-96ee-9906455d32a5",
    //         is_filling_form: "0",
    //         is_webhook_default: "1",
    //         webhook_url: "",
    //         license_name: "Boss Tejo",
    //         license_phone_number: "6285274397773",
    //       },
    //       {
    //         number: 4,
    //         id: "3",
    //         network_id: "1",
    //         intent_code: "REQUEST_SCAN_QRCODE_WA",
    //         service_name: "scan_qrcode_wa",
    //         base_url: "http://localhost:8500/prod",
    //         endpoint_path: "/go-omni-v2/zeus/ai-flow/scanqrcode",
    //         http_method: "POST",
    //         auth_type: "bearer",
    //         credential_encrypted:
    //           "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk",
    //         headers_json:
    //           '{"Content-Type":"application/json","Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk"}',
    //         request_mapping_json:
    //           '{\n  "email": "$.entities.email",\n  "nowa": "$.entities.nowa"\n}',
    //         response_mapping_json:
    //           '{\r\n  "success": "$.success",\r\n  "code": "$.code",\r\n  "message": "$.message",\r\n  "message_type": "$.data.message_type",\r\n  "message_caption": "$.data.message_caption",\r\n  "message_file_url": "$.data.message_file_url"\r\n}',
    //         is_active: "1",
    //         note: "request scan qrcode waajo. perlu no wa akun dan nomor whatsapp",
    //         create_datetime: "1768135661",
    //         update_datetime: "1768135661",
    //         license_id: "8ee48521-f786-4e4c-96ee-9906455d32a5",
    //         is_filling_form: "0",
    //         is_webhook_default: "1",
    //         webhook_url: "",
    //         license_name: "Boss Tejo",
    //         license_phone_number: "6285274397773",
    //       },
    //       {
    //         number: 5,
    //         id: "2",
    //         network_id: "1",
    //         intent_code: "CHECK_LICENSE",
    //         service_name: "license_api",
    //         base_url: "http://localhost:8500/prod",
    //         endpoint_path: "/omni-member/v1/zeus/ai-flow/member/check-license",
    //         http_method: "POST",
    //         auth_type: "bearer",
    //         credential_encrypted:
    //           "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk",
    //         headers_json:
    //           '{"Content-Type":"application/json","Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk"}',
    //         request_mapping_json: '{\r\n  "value": "$.entities.value"\r\n}',
    //         response_mapping_json:
    //           '{\r\n  "success": "$.success",\r\n  "code": 200,\r\n  "message": "$.message",\r\n  "message_type":  "$.data.message_type",\r\n  "message_caption": "$.data.message_caption"\r\n}',
    //         is_active: "1",
    //         note: "check license member waajo",
    //         create_datetime: "1768135661",
    //         update_datetime: "1768135661",
    //         license_id: "8ee48521-f786-4e4c-96ee-9906455d32a5",
    //         is_filling_form: "0",
    //         is_webhook_default: "1",
    //         webhook_url: "",
    //         license_name: "Boss Tejo",
    //         license_phone_number: "6285274397773",
    //       },
    //       {
    //         number: 6,
    //         id: "1",
    //         network_id: "1",
    //         intent_code: "CHECK_MEMBER",
    //         service_name: "member_api",
    //         base_url: "http://localhost:8500/prod",
    //         endpoint_path: "/omni-member/v1/zeus/ai-flow/member/check-member",
    //         http_method: "POST",
    //         auth_type: "bearer",
    //         credential_encrypted:
    //           "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk",
    //         headers_json:
    //           '{"Content-Type":"application/json","Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTk3NjAwOTEsImlhdCI6MTc2ODIyNDA5MSwidXNlcmlkIjoiMSIsInVzZXJuYW1lIjoidGltQHdhYWpvLmlkIn0.RjMB8Bjx-pWPGCi3sE8-qnAuHtS3WHnhzKgspN3sthk"}',
    //         request_mapping_json: '{\r\n  "value": "$.entities.value"\r\n}',
    //         response_mapping_json:
    //           '{\r\n  "success": "$.success",\r\n  "code": 200,\r\n  "message": "$.message",\r\n  "message_type":  "$.data.message_type",\r\n  "message_caption": "$.data.message_caption"\r\n}',
    //         is_active: "1",
    //         note: "check member waajo",
    //         create_datetime: "1768135661",
    //         update_datetime: "1768135661",
    //         license_id: "8ee48521-f786-4e4c-96ee-9906455d32a5",
    //         is_filling_form: "0",
    //         is_webhook_default: "1",
    //         webhook_url: "",
    //         license_name: "Boss Tejo",
    //         license_phone_number: "6285274397773",
    //       },
    //     ],
    //   },
    // };

    // this.totalRecords = response.data.totalRecords;
    // this.rowPage = response.data.page;
    // this.rows = response.data.data;
    this.currentPage = this.serverParams.page;
  },
  methods: {
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    fetchData(param = null) {
      if (this.requester) {
        this.channel.send({
          action: "created",
          requester: this.requester, // id tab peminta
          data: param,
        });
        setTimeout(() => {
          if (param.isExit == 1) {
            try {
              window.close();
            } catch (e) {
              /* ignore */
            }
          }
        }, 500);
      }
      this.searchData();
    },
    actionPublish() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000,
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to change status of the " +
          this.selectedTable.length +
          " messages to Publish?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      })
        .then(async (r) => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
            };
            this.$store
              .dispatch("automation/actionPublishTextReply", newParam)
              .then((response) => {
                this.$fire({
                  title: "Success Publish",
                  text: "The data was successfully change to Publish",
                  type: "success",
                  timer: 2000,
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch((e) => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    actionDraft() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000,
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to change status of the " +
          this.selectedTable.length +
          " messages to Draft?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      })
        .then(async (r) => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
            };
            this.$store
              .dispatch("automation/actionDraftTextReply", newParam)
              .then((response) => {
                this.$fire({
                  title: "Success Draft",
                  text: "The data was successfully change to Draft",
                  type: "success",
                  timer: 2000,
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch((e) => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000,
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " messages?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      })
        .then(async (r) => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
            };
            this.$store
              .dispatch("automation/actionDeleteTextReply", newParam)
              .then((response) => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000,
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch((e) => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("automation/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id,
      };
      let formData = await {};
      await this.$store
        .dispatch("automation/detailTextReplyForEdit", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          data.header.is_custom_url = false;
          data.header.is_enable_attach_file = false;
          if (data.header.image_url != "") {
            data.header.is_enable_attach_file = true;
          }
          formData = data;
        });
      // console.log("formData::", formData);
      // formData.id = id;
      await this.$store.dispatch("automation/actFormParamTRSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    async copyData(id) {
      //set false dulu
      this.$store.dispatch("automation/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id,
      };
      let formData = await {};
      await this.$store
        .dispatch("automation/detailTextReplyForEdit", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          formData = data;
        });
      // console.log("formData::", formData);
      formData.header.copy = true;
      await this.$store.dispatch("automation/actFormParamTRSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    draftData(id) {
      let dataParam = {};
      dataParam = {
        id: id,
      };
      this.$store
        .dispatch("automation/updateTextReplyDraft", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          this.searchData();
          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000,
          });
        });
    },
    publishData(id) {
      let dataParam = {};
      dataParam = {
        id: id,
      };
      this.$store
        .dispatch("automation/updateTextReplyPublish", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          this.searchData();
          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000,
          });
        });
    },
    deleteData(id) {
      this.$fire({
        title: "Are you sure you will delete this data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then(async (r) => {
        if (typeof r.value != "undefined" && r.value == true) {
          let dataParam = {};
          dataParam = {
            id: id,
          };
          this.$store
            .dispatch("automation/deleteTextReply", dataParam) // sesuai kan dengan method di API
            .then((response) => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000,
              });
            });
        }
      });
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("automation/setIsShowForm", false);
        this.selectedLicense = [];

        let formData = {
          header: {
            id: "",
            license_id: "",
            message: "",
            trigger_on: "all",
            trigger_on_some_type: "any",
            frequency_per_person: 15,
            is_enable_away_message: 0,
            is_enable_away_message_status: false,
            message_away: "",
            footer_message: "",
            footer_message_status: false,
          },
          detail_button: [
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
          ],
          detail_button_away: [
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
          ],
          detail_some: [
            {
              select_variable: "conversation",
              condition: "start_with",
              text: "",
            },
          ],
          start_away: "19:00",
          end_away: "08:00",
        };
        this.$store.dispatch("automation/actFormParamTRSt", formData);
      }
      var that = this;
      setTimeout(function () {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("automation/setIsShowForm", true);
        }
      }, 1000);
    },

    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage,
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("aiKey/listIntentWorkflowUser", this.serverParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
    const { action, requester } = this.$route.query;
    if (action == "add") {
      setTimeout(() => {
        this.requester = requester || null;

        this.channel = this.$util.createChannel("member-type-channel");
        this.$refs.formBc.click(); // Click on the checkbox
      }, 500);
    }
  },
  name: "broadcast-list",
};
</script>



// WEBPACK FOOTER //
// src/views/ai/workflow/list.vue